(function () {

    angular
        .module('smartertoolsApp')
        .controller('accountLoginsController', ['$scope', '$timeout', 'accountService', 'notificationFactory', accountLoginsController]);

    function accountLoginsController($scope, $timeout, accountService, notify) {
        const vm = this;
        vm.authorizedLogins = null;
        vm.isSaving = false;
        vm.isPrimaryAccountHolder = false;

        // Functions
        vm.attachFocusEvents = attachFocusEvents;
        vm.Reload = Reload;
        vm.viewLogin = viewLogin;
        vm.addLogin = addLogin;
        vm.saveLogin = saveLogin;
        vm.deleteLogin = deleteLogin;
        vm.doDeleteLogin = doDeleteLogin;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.Reload();
        }

        function attachFocusEvents() {
            if (!vm.focusEventsAttached) {
                document.getElementById('account-logins-view')
                    .addEventListener('shown.bs.modal', () => {
                        if (vm.selectedLogin && vm.selectedLogin.UserId)
                            document.getElementById('accountLoginFullName').focus();
                        else
                            document.getElementById('accountLoginEmail').focus();
                    });
                vm.focusEventsAttached = true;
            }
        }

        function Reload() {
            $scope.accountCtrl.isLoading++;
            accountService.getAccountSettings()
                .then((data) => {
                    $scope.accountCtrl.isLoading--;
                    vm.authorizedLogins = data.AuthorizedLogins;
                    vm.isPrimaryAccountHolder = data.IsPrimaryAccountHolder;
                    $timeout(() => RecalculateAllFloatLabelControls());
                })
                .catch((err) => { $scope.accountCtrl.isLoading--; });
        }

        function viewLogin(login) {
            vm.selectedLogin = angular.copy(login);
            vm.isSaving = false;
            vm.isDeleting = false;
            vm.attachFocusEvents();
            vm.LoginsViewForm.$setPristine();
            vm.LoginsViewForm.$setUntouched();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('account-logins-view')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function addLogin() {
            vm.selectedLogin = {
                Permissions: {
                    ActivateLicenses: true,
                    Purchase: true,
                    ViewInvoices: true,
                    ResellerFunctions: true,
                    LeaseProviderFunctions: true
                },
            };
            vm.isSaving = false;
            vm.isDeleting = false;
            vm.attachFocusEvents();
            vm.LoginsViewForm.$setPristine();
            vm.LoginsViewForm.$setUntouched();
            $timeout(() => {
                bootstrap.Modal.getOrCreateInstance(document.getElementById('account-logins-view')).show();
                $timeout(() => RecalculateAllFloatLabelControls());
            }, 50);
        }

        function saveLogin() {
            if (vm.LoginsViewForm.$invalid)
                return;
            vm.isSaving = true;
            accountService.saveLogin(vm.selectedLogin)
                .then(() => {
                    vm.isSaving = false;
                    notify.success('Authorized Login was updated.');
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('account-logins-view')).hide();
                    vm.Reload();
                })
                .catch((response) => {
                    vm.isSaving = false;
                    notify.error((response && response.data) || 'There was a problem updating the item.');
                });
        }

        function deleteLogin() {
            if (vm.selectedLogin.UserId)
                vm.isDeleting = true;
        }

        function doDeleteLogin() {
            vm.isSaving = true;
            accountService.deleteLogin(vm.selectedLogin)
                .then(() => {
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('account-logins-view')).hide();
                    vm.isDeleting = false;
                    vm.isSaving = false;
                    notify.success('Login was deleted');
                    vm.Reload();
                })
                .catch(() => {
                    vm.isDeleting = false;
                    vm.isSaving = false;
                    notify.error('There was a problem updating the item.');
                });
        }
    }

})();